import { create } from 'zustand'

type MaxLayoutStoreState = {
  isSidebarCollapsed: boolean
}

type MaxLayoutStoreActions = {
  setSidebarCollapsed: (isCollapsed: boolean) => void
  collapseSidebar: () => void
  expandSidebar: () => void
  toggleSidebar: () => void
}

type MaxLayoutStore = MaxLayoutStoreState & MaxLayoutStoreActions

const useMaxLayoutStore = create<MaxLayoutStore>((set) => ({
  isSidebarCollapsed: false,

  setSidebarCollapsed: (isSidebarCollapsed) => set({ isSidebarCollapsed }),
  collapseSidebar: () => set({ isSidebarCollapsed: true }),
  expandSidebar: () => set({ isSidebarCollapsed: false }),
  toggleSidebar: () =>
    set((state) => ({
      isSidebarCollapsed: !state.isSidebarCollapsed,
    })),
}))

export default useMaxLayoutStore
